function ExpenseUpload() {
  return null;
}

export default ExpenseUpload;
